import { render, staticRenderFns } from "./ItemsTransaction.vue?vue&type=template&id=65a0dbfe&scoped=true"
import script from "./ItemsTransaction.vue?vue&type=script&lang=js"
export * from "./ItemsTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a0dbfe",
  null
  
)

export default component.exports